import React, { useEffect, useState } from 'react'
import FormRow from './FormRow'
import AddUser from './AddUser'
import { MenuItem, Typography } from '@mui/material'
import Admin from 'api/Admin'
import Autocomplete from 'components/Autocomplete'
import useForm from 'js/hooks/useForm'

const SelectUser = ({ onChange, value, name }) => {

    const [data, setData] = useState([])
    const [message, setMessage] = useState("")
    const [search, setSeach] = useState("")
    const [open, setOpen] = useState(false)
    let { firstname } = data.find(d => d.id == value) || {}

    const getData = async () => {
        try {
            const res = await Admin.Benefactor.getMany()
            setData(res.data.reverse())
        } catch (error) {
            setMessage(error.message)
        }
    }

    useEffect(() => {
        getData()
    }, [])



    const sets = data.filter(d => {
        if (!search) return 1
        return Object.values(d).filter(d => d).map(d => d.toString().toLowerCase()).join(" ").includes(search.toLowerCase())
    })

    return <Autocomplete.Container onClose={() => setOpen(false)}>
        <input
            onFocus={() => setOpen(true)}
            readOnly
            value={value}
            name={name}
            placeholder='Select Beneficiary'
        />
        {open &&
            <Autocomplete.Popper>
                <Typography color={"error"}>{message}</Typography>
                <input
                    onFocus={() => setOpen(true)}
                    onChange={e => setSeach(e.target.value)}
                    value={search}
                    autoFocus
                    placeholder='Search User'
                    style={{ position: "sticky", top: 0, background: "white", zIndex: 10 }}
                />
                {sets.map(d => <MenuItem onClick={() => onChange(d)} key={d.id} sx={{ borderBottom: "1px solid #0002" }}>
                    <div>
                        <div>{d.firstname} {d.lastname}</div>
                        <Typography color={"#999"} fontSize={10}>#{d.id} | {d.phoneno} | {d.email}</Typography>
                    </div>
                </MenuItem>)}
            </Autocomplete.Popper>}
    </Autocomplete.Container>
}


const schema = [
    {
        name: "phoneno",
        error: { required: true }
    },
    {
        name: "purpose",
        type: "select",
        "label": "Select the purpose of grant:",
        "required": true,
        error: { "maxlength": 255, "required": true, },
        options: [
            { label: "Select one", value: "" },
            "Education",
            "Home Loan/Renovation",
            "Medical",
            "Major Purchase",
            "Existing Debt",
            "Small Business",
            "Retirement",
            "Vehicle Purchase"
        ]
    },
    {
        name: "short_description",
        "label": "Short Description",
        "type": "textarea",
        "required": true,
        error: { "maxlength": 1000, "required": true, name: "short description" }
    }
]

const user_id = schema[0]

export default function Step1({ onChange, payload }) {


    const { data, isError, setData, inputProps, setTouched, errors, touched } = useForm({ schema, payload })

    const onClick = () => {
        if (isError()) {
            setTouched(true)
            return
        }
        onChange(data)
    }

    const handleChange = ({ id, ...others }) => {
        setData({ ...data, ...others })
    }


    useEffect(() => {
        const btn = document.getElementById("submit")
        btn.addEventListener("click", onClick)

        return () => {
            btn.removeEventListener("click", onClick)
        }

    }, [data, payload])


    return (
        <div>
            <FormRow required touched={touched} label={"Beneficiary User"} errorText={errors[user_id.name]}>
                <SelectUser {...inputProps(user_id)} onChange={handleChange} />
                <AddUser onChange={res => handleChange(res.data)} />
            </FormRow>
            {schema.slice(1).map(d => <FormRow key={d.name} {...inputProps(d)} />)}
        </div>
    )
}
